import neurodeManager from "@/neurodes/Nodes/manager";
import { nodeSelection } from "../selectionData";

export function getDefaultNodeData(id: string, type: string) {
  switch (type) {
    case "ask_question": {
      return {
        nodeType: "default",
        data: { title: "Ask me a question" },
        variableName: `${id}_${type}`,
      };
    }
    case "email": {
      return {
        nodeType: "default",
        data: { title: "What is your email address" },
        variableName: `${id}_${type}`,
      };
    }
    case "phone": {
      return {
        nodeType: "default",
        data: { title: "What is your phone number" },
        variableName: `${id}_${type}`,
      };
    }
    case "name": {
      return {
        nodeType: "default",
        data: { title: "What is your name" },
        variableName: `${id}_${type}`,
      };
    }
    case "job": {
      return {
        nodeType: "default",
        data: { title: "What is your curret job" },
        variableName: `${id}_${type}`,
      };
    }
    case "company": {
      return {
        nodeType: "default",
        data: { title: "What is your curret company" },
        variableName: `${id}_${type}`,
      };
    }
    case "username": {
      return {
        nodeType: "default",
        data: { title: "Enter your user name" },
        variableName: `${id}_${type}`,
      };
    }
    case "address": {
      return {
        nodeType: "default",
        data: { title: "What is your address" },
        variableName: `${id}_${type}`,
      };
    }
    case "button": {
      return {
        nodeType: "default",
        data: { title: "Choose any option" },
        variableName: `${id}_${type}`,
        buttonDetails: {
          buttons: [
            {
              name: "option",
              value: "0",
              outputId: "output_1",
            },
          ],
          variableName: `${id}_${type}(value)`,
          showImg: false,
        },
      };
    }
    case "result": {
      return {
        nodeType: "actions",
        resultNodeDetails: { formula: "" },
        variableName: `${id}_${type}`,
      };
    }
    case "sendMessage": {
      return {
        nodeType: "triggers",
        data: { title: "message" },
      };
    }
    case "socialData": {
      return {
        nodeType: "campaign",
        webhookData: {
          isConfigured: false,
          variables: [],
        },
      };
    }
    case "segment": {
      return {
        nodeType: "campaign",
        audienceData: {
          name: "",
          type: "uploadList",
          listId: "",
          segmentId: "",
          scheduleType: "now",
          scheduleTime: "",
        },
      };
    }
    case "liveChat": {
      return {
        nodeType: "default",
        data: { title: "Live Chat started..." },
        liveChatData: {
          agents: {},
          useAssigneesAsAgents: false,
        },
      };
    }
    case "sendEmail": {
      return {
        nodeType: "actions",
        sendEmailDetails: {
          emailConfig: "",
          from: "",
          to: "",
          replyTo: "",
          content: {
            subject: "",
            body: "",
          },
        },
      };
    }
    case "sendSMS": {
      return {
        nodeType: "actions",
        sendSMSDetails: {
          smsConfig: "",
          to: "",
          smsBody: "",
        },
      };
    }
    case "hitApi": {
      const rows = Array.from({ length: 5 }, () => ({
        key: "",
        value: "",
        testValue: "",
      }));

      return {
        nodeType: "actions",
        hitApiDetails: {
          method: "GET",
          url: "",
          headers: rows,
          params: rows,
          body: rows,
        },
      };
    }
    case "delayAction": {
      return {
        nodeType: "actions",
        delayAction: {
          time: 10,
          timeFormat: "seconds",
        },
      };
    }
    case "pushNotification": {
      return {
        nodeType: "actions",
        pushNotification: {
          pushConfigId: "",
          title: "",
          body: "",
        },
      };
    }
    case "abTest": {
      return {
        nodeType: "actions",
        abTestData: {
          percent: 50,
          pathA: 0,
          pathB: 0,
        },
      };
    }
    case "condition": {
      return {
        nodeType: "actions",
        conditionData: [
          {
            variable: "",
            value: "",
            comparison_operator: "EQUAL TO",
            logical_operator: "AND",
          },
        ],
      };
    }
    case "assignees": {
      return {
        nodeType: "actions",
        assigneesData: {
          logicType: "round_robin",
          roundRobinData: {},
          conditionalData: [
            {
              assigneeId: "",
              conditions: [
                {
                  variable: "",
                  value: "",
                },
              ],
            },
            {
              assigneeId: "",
              conditions: [],
            },
          ],
          sendEmailToAssignee: true,
        },
        variableName: `${id}_${type}`,
      };
    }
    case "whatsApp": {
      return {
        nodeType: "actions",
        whatsappDetails: {
          // configId: "",
          templateName: "",
          lang: "",
          to: "",
          smsBody: "",
        },
      };
    }
    case "envoie": {
      return {
        nodeType: "actions",
        templateDetails: {
          templateId: "",
          apiKey: "",
        },
        variableName: `${id}_${type}`,
      };
    }
    case "openai": {
      return {
        nodeType: "actions",
        openAiData: {
          configId: "",
          model: "",
          prompt: "",
          showParams: false,
          params: {},
        },
        variableName: `${id}_${type}`,
      };
    }
    case "linkedIn": {
      return {
        nodeType: "actions",
        linkedInData: {
          nodeType: null,
          configId: "",
          name: "",
          email: "",
          profileId: "",
          message: "",
        },
      };
    }
    case "sticky": {
      return {
        nodeType: "default",
        stickyDetails: { content: "" },
      };
    }
    case "salesForce": {
      return {
        nodeType: "actions",
        salesForceData: {
          configId: "",
          listId: "",
          payload: {},
        },
      };
    }
    default:
      return null;
  }
}

export function getDefaultNeurodeData(key) {
  // need to completly figure this out yet
  const { properties } = neurodeManager.getNodeWithProperties(key);

  const parameters = Object.fromEntries(
    properties.map((prop) => [prop.name, prop.default]),
  );

  const neurodeData: any = nodeSelection.NODE_DATA[key];
  const defaultParameterValues = neurodeManager
    .getFilteredParameters(properties, {
      parameters,
    })
    .reduce((acc, curr) => {
      acc[curr.name] = curr.default;
      return acc;
    }, {});

  return {
    nodeType: "actions",
    neurodeData: {
      parameters: defaultParameterValues,
      typeVersion: neurodeData.typeVersion,
      type: neurodeData.key,
    },
  };
}
